// Default imports
import 'expose-loader?exposes=jquery-ui!jquery-ui';
// Change JQueryUI plugin names to fix name collision with Bootstrap.
$.widget.bridge('uitooltip', $.ui.tooltip);
$.widget.bridge('uibutton', $.ui.button);
import 'bootstrap/js/src/index.js';

import 'expose-loader?exposes=sortable!../../node_modules/jquery-ui/ui/widgets/sortable.js';
import '../../common/assets/yii2/yii.js';
import 'expose-loader?exposes=pjax!../../node_modules/yii2-pjax/jquery.pjax.js';
import 'expose-loader?exposes=gridView!../../vendor/yiisoft/yii2/assets/yii.gridView.js';
import 'expose-loader?exposes=nestedSortable!../../vendor/firegroup/fire-core-nested-sets/src/assets/js/jquery.mjs.nestedSortable.js';


// Import generated assets
import './assets/generatedAssets';

// Import styles
import '../styles/styles.js';

// Custom imports
import '../javascript/partials.js';
import '../javascript/lazyload.js';